<app-preview-layout>
  <ng-container previewTitle> {{ 'NEW_ROSTER' | translate | titlecase }}</ng-container>
  @if (!isOpenedInDrawer) {
    <ng-container backBtn>
      <!-- WCAG 4.1.2 — icon-only navigation control -->
      <button type="button" class="round-btn btn-back" (click)="onBack()" [attr.aria-label]="'BACK' | translate">
        <i class="ftmi-arrow-left" aria-hidden="true"></i></button
      ></ng-container>
    }

    @if (isOpenedInDrawer) {
      <ng-container closeBtn>
        <button type="button" class="round-btn btn-back" (click)="onClose()" [attr.aria-label]="'CLOSE' | translate">
          <i class="ftmi-cross" aria-hidden="true"></i>
        </button>
      </ng-container>
    }

    <ng-container previewContent>
      <form class="container" [formGroup]="form">
        <div class="white-panel preview-panel">
          <div class="row">
            <div [ngClass]="{ 'col-lg-12': isOpenedInDrawer, 'col-lg-6 pr-lg-3': !isOpenedInDrawer }">
              <div class="cord-label">
                <h3 class="label">{{ 'ROSTER_DETAILS' | translate }}</h3>
              </div>
              <app-roster-general-settings [form]="form"> </app-roster-general-settings>
            </div>
            <div [ngClass]="{ 'col-lg-12': isOpenedInDrawer, 'col-lg-6 pr-lg-3': !isOpenedInDrawer }">
              <app-roster-students-upload [form]="form"></app-roster-students-upload>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container footerContent>
      <button type="button" class="btn btn-padded btn-radius btn-outline-primary mx-2" (click)="onBack()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary btn-padded btn-radius mx-2" (click)="onSubmit()">
        {{ 'ADD' | translate }}
      </button>
    </ng-container>
  </app-preview-layout>
